import React from "react";
import { Box, Stack, Skeleton } from "@mui/material";
import { T, WEEK_DAYS } from "../../constants/todoTokens";

const SkeletonCalendar = () => (
  <Box sx={{ bgcolor: T.surface, borderRadius: "16px", border: `1px solid ${T.border}`, overflow: "hidden", boxShadow: T.shadow.md }}>
    {/* Header */}
    <Stack
      direction="row" alignItems="center" justifyContent="space-between"
      sx={{ px: 3, py: 2.5, borderBottom: `1px solid ${T.border}` }}
    >
      <Skeleton variant="text" width={160} height={32} />
      <Stack direction="row" gap={1}>
        <Skeleton variant="circular" width={32} height={32} />
        <Skeleton variant="circular" width={32} height={32} />
      </Stack>
    </Stack>

    {/* Day-name row */}
    <Box sx={{ display: "grid", gridTemplateColumns: "repeat(7, 1fr)", borderBottom: `1px solid ${T.border}` }}>
      {WEEK_DAYS.map((d) => (
        <Box key={d} sx={{ py: 1, display: "flex", justifyContent: "center" }}>
          <Skeleton variant="text" width={24} height={18} />
        </Box>
      ))}
    </Box>

    {/* Cells */}
    <Box sx={{ display: "grid", gridTemplateColumns: "repeat(7, 1fr)" }}>
      {[...Array(35)].map((_, i) => (
        <Box
          key={i}
          sx={{ minHeight: 100, p: 1, borderRight: `1px solid ${T.border}`, borderBottom: `1px solid ${T.border}` }}
        >
          <Skeleton variant="circular" width={26} height={26} sx={{ mb: 0.5 }} />
          {i % 3 === 0 && <Skeleton variant="rounded" height={18} sx={{ borderRadius: "4px", mb: "3px" }} />}
          {i % 5 === 0 && <Skeleton variant="rounded" height={18} sx={{ borderRadius: "4px" }} />}
        </Box>
      ))}
    </Box>
  </Box>
);

export default SkeletonCalendar;
